import Cookies from "universal-cookie";
import { GetToken } from "../components/util/Helpers/Auth";
import { URL_BACKEND } from "../controllers/config";

export const usePermissions = async () => {
  const cookies = new Cookies();

  const permissions = async () => {
    const fetchPermissions = await fetch(
      `${URL_BACKEND}/permissaoFuncionalidade/checkPermission`,
      {
        headers: {
          "User-Token": GetToken(),
        },
      }
    ).then(async (res) => {
      const status = res.status;
      const { permissions, role } = await res.json();

      return { permissions, role, status };
    });

    const { permissions, role, status } = fetchPermissions;

    if (status === 406) {
      cookies.remove("User-Token", { path: "/" });
      window.location.href = "/";
    }

    const formattedPermissions = permissions.reduce((acc, curr) => {
      // eslint-disable-next-line
      return (acc[curr] = true), acc;
    }, {});

    return { userPermissions: formattedPermissions, userRole: role };
  };

  return permissions();
};
